module.exports = __webpack_public_path__ + "assets/img/cat-smirk.7556d400.jpg";